var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeFullScreenVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8006 14.0506L4.875 19.9761V17.875C4.875 17.4265 4.511 17.0625 4.0625 17.0625C3.614 17.0625 3.25 17.4265 3.25 17.875V21.9375C3.25 22.386 3.614 22.75 4.0625 22.75H8.125C8.5735 22.75 8.9375 22.386 8.9375 21.9375C8.9375 21.489 8.5735 21.125 8.125 21.125H6.02388L11.9494 15.1995C12.2667 14.8822 12.2667 14.3679 11.9494 14.0506C11.6326 13.7333 11.1174 13.7333 10.8006 14.0506Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9374 3.25H17.8749C17.4264 3.25 17.0624 3.614 17.0624 4.0625C17.0624 4.511 17.4264 4.875 17.8749 4.875H19.976L14.0505 10.8006C13.7332 11.1178 13.7332 11.6322 14.0505 11.9494C14.2093 12.1083 14.4169 12.1875 14.6249 12.1875C14.8329 12.1875 15.0405 12.1083 15.1993 11.9494L21.1249 6.02387V8.125C21.1249 8.5735 21.4889 8.9375 21.9374 8.9375C22.3859 8.9375 22.7499 8.5735 22.7499 8.125V4.0625C22.7499 3.614 22.3859 3.25 21.9374 3.25Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeFullScreenVideo);
export default __webpack_public_path__ + "static/media/make_full_screen_video.e1b4f49ec846d81d74d90d54cf6eae63.svg";
export { ForwardRef as ReactComponent };